<template>
  <div>
    <div class="d-flex align-center" style="gap: 10px">
      <v-card class="pa-1 bg-smokeDark" rounded="lg" flat>
        <v-btn-toggle v-model="mode" mandatory density="compact">
          <v-btn
            v-for="item in [
              {
                text: 'Articles',
                icon: 'mdi-file-document',
                value: 'articles',
              },
              {
                text: 'Sources',
                icon: 'mdi-source-branch',
                value: 'sources',
              },
            ]"
            :key="item.value"
            :value="item.value"
            rounded="lg"
          >
            <v-icon size="small" class="mr-2">{{ item.icon }}</v-icon>
            {{ item.text }}
          </v-btn>
        </v-btn-toggle>
      </v-card>
      <v-menu v-model="sourceMenu" :close-on-content-click="false">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="flat"
            color="smokeDark"
            prepend-icon="mdi-plus"
            @click="sourceMenu = true"
            >Add source</v-btn
          >
        </template>
        <v-card class="pa-4">
          <v-text-field label="Source name" v-model="sourceName"></v-text-field>
          <v-text-field label="Source URL" v-model="sourceUrl"></v-text-field>
          <v-btn @click="addSource" variant="flat" color="accent"
            >Add source</v-btn
          >
          <v-btn @click="sourceMenu = false" variant="text" color="accent"
            >Cancel</v-btn
          >
        </v-card>
      </v-menu>
    </div>
    <SourcesView v-if="mode === 'sources'" />

    <div v-if="mode === 'articles'" class="mt-4">
      <div
        class="d-flex flex-column"
        style="gap: 16px"
        v-if="allSources.length > 0 && allSources[0]?.items?.length > 0"
      >
        <v-card
          elevation="0"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 8px"
        >
          <div>
            <!-- Header Section -->
            <v-data-table-virtual
              :headers="[
                { text: 'Title', value: 'title' },
                { text: 'Match', value: 'match' },
                { text: 'Status', value: 'status' },
              ]"
              :items="allSources[0].items"
              height="calc(100vh - 150px)"
              item-value="title"
            ></v-data-table-virtual>
          </div>
        </v-card>
      </div>
      <div v-else class="text-center pa-8 text-medium-emphasis">
        No articles found. Add a source and fetch articles to see them here.
      </div>
    </div>
  </div>
</template>

<script>
import SourcesView from "@/components/sources/SourcesView.vue";
import { mapState } from "vuex";

export default {
  components: {
    SourcesView,
  },
  computed: {
    ...mapState({
      categories: (state) => state.posts.categories,
      query: (state) => state.posts.query,
      allSources: (state) => state.sources.allSources,
    }),
  },
  data() {
    return {
      mode: "articles",
      sourceMenu: false,
      sourceName: "",
      sourceUrl: "",
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatUrl(url) {
      if (!url) return "";
      try {
        const urlObj = new URL(url.startsWith("http") ? url : `https://${url}`);
        return urlObj.hostname.replace("www.", "");
      } catch {
        return url;
      }
    },
    turnIntoPost(item) {
      // Add your turn into post logic here
      console.log("Turn into post", item);
    },
    deleteItem(item) {
      if (item) {
        this.$store.dispatch("deleteItem", item);
      }
    },
    addSource() {
      this.$store.dispatch("saveSource", {
        url: this.sourceUrl,
        name: this.sourceName,
        last_fetch: null,
        category: null,
      });
      this.sourceName = "";
      this.sourceUrl = "";
      this.sourceMenu = false;
    },
  },
};
</script>
